<template>
    <b-modal ref="mdlDiagnosiConcomitanti" id="mdlDiagnosiConcomitanti" :title="isReadOnly ? 'Lista diagnosi' : 'Diagnosi Concomitanti'" size="xl" centered scrollable no-close-on-backdrop no-close-on-esc hide-header-close @hidden="onHidden">
        <p v-if="isReadOnly && listaDiagnosiConcomitanti.length === 0" class="text-muted mb-0">Nessuna diagnosi associata.</p>
        <div v-for="(diagnosi, index) in listaDiagnosiConcomitanti" :key="index" class="border rounded p-3 mb-3">
            <div class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2">
                <strong class="text-primary">Diagnosi {{ index + 1 }}</strong>
                <b-button v-if="!isReadOnly" size="sm" variant="outline-primary" :title="'Cerca diagnosi ICD9 ' + (index + 1)" :aria-label="'Cerca diagnosi ICD9 ' + (index + 1)" @click="onClickSearchIcdix(index)">
                    <b-icon icon="search"></b-icon>
                    Cerca ICD9
                </b-button>
            </div>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4" class="mb-2 mb-lg-0">
                    <label class="sa-label-data diagnosi-concomitante-label">Diagnosi amministrativa di dimissione</label>
                    <span v-if="isReadOnly" class="d-block diagnosi-concomitante-value">{{ diagnosi.diagnosiAmministrativaDimissione || "-" }}</span>
                    <b-form-textarea v-else v-model="diagnosi.diagnosiAmministrativaDimissione" rows="1" max-rows="1" no-resize></b-form-textarea>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="3" lg="2" xl="2" class="mb-2 mb-lg-0">
                    <label class="sa-label-data diagnosi-concomitante-label">Stadiazione</label>
                    <span v-if="isReadOnly" class="d-block">{{ getDescrizioneOpzione(diagnosi.stadiazione, stadiazioneOptions) }}</span>
                    <b-form-select v-else v-model="diagnosi.stadiazione" :options="stadiazioneOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="3" lg="2" xl="2" class="mb-2 mb-lg-0">
                    <label class="sa-label-data diagnosi-concomitante-label">Presente ricovero</label>
                    <span v-if="isReadOnly" class="d-block">{{ getDescrizioneOpzione(diagnosi.presenteRicovero, siNoOptions) }}</span>
                    <b-form-select v-else v-model="diagnosi.presenteRicovero" :options="siNoOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="3" lg="2" xl="2" class="mb-2 mb-lg-0">
                    <label class="sa-label-data diagnosi-concomitante-label">Lateralità</label>
                    <span v-if="isReadOnly" class="d-block">{{ getDescrizioneOpzione(diagnosi.lateralita, lateralitaOptions) }}</span>
                    <b-form-select v-else v-model="diagnosi.lateralita" :options="lateralitaOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="3" lg="2" xl="2" class="mb-2 mb-lg-0">
                    <label class="sa-label-data diagnosi-concomitante-label">Posizione diagnosi riabilitativa</label>
                    <span v-if="isReadOnly" class="d-block">{{ getDescrizioneOpzione(diagnosi.posizioneDiagnosiRiabilitativa, posizioneDiagnosiRiabilitativaOptions) }}</span>
                    <b-form-select v-else v-model="diagnosi.posizioneDiagnosiRiabilitativa" :options="posizioneDiagnosiRiabilitativaOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="onClickChiudi">Chiudi</b-button>
            <template v-else>
                <b-button variant="outline-danger" @click="onClickChiudi">Annulla</b-button>
                <b-button variant="outline-success" @click="onConferma">Conferma</b-button>
            </template>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        isReadOnly: { type: Boolean, default: false },
    },
    computed: {
        lateralitaOptions() {
            return [...this.siNoOptions, { value: "N/A", text: "N/A" }];
        },
    },
    data() {
        return {
            isOpen: false,
            listaDiagnosiConcomitanti: [],
            siNoOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "SI", text: "Sì" },
                { value: "NO", text: "No" },
            ],
            stadiazioneOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "1", text: "1 - Tumore localizzato, confinato all'organo di origine." },
                { value: "2", text: "2 - Infiltrazione locale extra-organo." },
                { value: "3", text: "3 - Metastasi ai linfonodi regionali." },
                { value: "4", text: "4 - Infiltrazione locale extra-organo e metastasi ai linfonodi regionali." },
                { value: "5", text: "5 - Metastasi a distanza." },
                { value: "6", text: "6 - Metastasi ai linfonodi non regionali." },
                { value: "7", text: "7 - Non confinato all'organo di origine, ma non è noto se sia 2, 3, 4, 5 o 6." },
                { value: "8", text: "8 - Nessuna invasione degli organi distanti, ma non è noto se sia 1, 2, 3 o 4." },
                { value: "9", text: "9 - Stadio ignoto / non specificato." },
            ],
            posizioneDiagnosiRiabilitativaOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "EZIOLOGICO", text: "Eziologico" },
                { value: "MARCATORE", text: "Marcatore" },
                { value: "CONCOMITANTE", text: "Concomitante" },
            ],
        };
    },
    methods: {
        getDescrizioneOpzione(value, options) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }
            let opzione = options.find((item) => String(item.value) === String(value));
            return opzione ? opzione.text : value;
        },
        show(items) {
            let me = this;
            let lista = Array.isArray(items) ? JSON.parse(JSON.stringify(items)) : [];
            if (me.isReadOnly) {
                me.listaDiagnosiConcomitanti = lista.filter((diagnosi) => diagnosi && [
                    diagnosi.diagnosiAmministrativaDimissione,
                    diagnosi.stadiazione,
                    diagnosi.presenteRicovero,
                    diagnosi.lateralita,
                    diagnosi.posizioneDiagnosiRiabilitativa,
                ].some((value) => value !== null && value !== undefined && String(value).trim() !== ""));
                let ordinePosizioni = { EZIOLOGICO: 0, MARCATORE: 1, CONCOMITANTE: 2 };
                me.listaDiagnosiConcomitanti.sort((a, b) =>
                    (ordinePosizioni[a.posizioneDiagnosiRiabilitativa] ?? 3) - (ordinePosizioni[b.posizioneDiagnosiRiabilitativa] ?? 3)
                );
            } else {
                me.listaDiagnosiConcomitanti = Array.from({ length: 5 }, (item, index) => ({
                    diagnosiAmministrativaDimissione: "",
                    stadiazione: null,
                    presenteRicovero: null,
                    lateralita: null,
                    posizioneDiagnosiRiabilitativa: null,
                    ...lista[index],
                }));
            }
            me.isOpen = true;
            me.$refs.mdlDiagnosiConcomitanti.show();
        },
        onClickSearchIcdix(index) {
            if (this.isReadOnly || !this.isOpen) {
                return;
            }
            this.$emit("onSearchDiagnosi", index);
        },
        setDiagnosiIcdix(index, diagnosi) {
            let me = this;
            if (me.isReadOnly || !me.isOpen || !me.listaDiagnosiConcomitanti[index] || !diagnosi.codiceIcdix) {
                return;
            }
            me.listaDiagnosiConcomitanti[index].diagnosiAmministrativaDimissione = "(" + diagnosi.codiceIcdix + ") " + diagnosi.descrizioneIcdix;
        },
        onConferma() {
            if (this.isReadOnly || !this.isOpen) {
                return;
            }
            this.$emit("onConfirm", JSON.parse(JSON.stringify(this.listaDiagnosiConcomitanti)));
            this.$refs.mdlDiagnosiConcomitanti.hide();
        },
        onClickChiudi() {
            this.$refs.mdlDiagnosiConcomitanti.hide();
        },
        onHidden() {
            this.isOpen = false;
            this.$emit("onClose");
        },
    },
};
</script>

<style scoped>
.diagnosi-concomitante-value {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.diagnosi-concomitante-label {
    display: flex;
    align-items: flex-end;
    min-height: 4rem;
    padding-top: 0;
    margin-bottom: 0.5rem;
    line-height: 1.25;
}

@media (max-width: 575.98px) {
    .diagnosi-concomitante-label {
        min-height: 0;
    }
}
</style>
